import { useState } from 'react'
import { useMessages } from '@/i18n'
import { AiPromptIcon } from '../shared/AiPromptIcon'
import { messages } from './messages'

interface Props {
  open: boolean
  onToggle: () => void
}

/**
 * Оранжевая AI-звёздочка слева сверху — переключатель AI-панели. Сама не крутится:
 * при наведении доворачивается на 90°, клик её не поворачивает. Вынесен из `EditorShell` ради лимита длины
 * файла: состояние панели живёт в `editorSlice`.
 */
export const AiSidebarToggle = ({ open, onToggle }: Props) => {
  const m = useMessages(messages)
  const [hovered, setHovered] = useState(false)
  const angle = hovered ? 90 : 0
  // По центру шапки: `top-3` + 32px = центр на 28px при шапке `h-14`; низкое окно
  // (`short`, в том числе любой телефон) ужимает шапку до `h-11` — центр 22px,
  // и звёздочка без `short:top-1.5` висела на 6px ниже домика и названия.
  return (
    <button
      onClick={onToggle}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(false)}
      aria-label={open ? m.hideAiPanel : m.showAiPanel}
      className="absolute left-3 top-3 z-50 short:top-1.5 flex size-8 shrink-0 items-center justify-center rounded-lg"
    >
      <AiPromptIcon
        className="size-6 transition-transform duration-500 [transition-timing-function:cubic-bezier(0.65,0,0.35,1)]"
        style={{ transform: `rotate(${angle}deg)` }}
      />
    </button>
  )
}
